<template>
    <div class="loader" v-if="isMessage.status && token && isMessage.progress.progress">
        <!-- v-if="isMessage.status && token && isMessage.progress.progress" -->
        <!-- <button class="btn btn-primary" type="button" disabled>
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            <span class=""> {{ "Import in progress......" }}</span>
        </button> -->

        <div class="progress">
            <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="{ width: isMessage.progress.progress + '%' }"
                aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{ isMessage.progress.progress }}%</div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    props: {
        isMessage: {
            type: Object,
            default: false
        },
        token: {
            type: String,
            default: false
        }
    }
}
</script>
<style>
.loader {
    z-index: 99999;
    position: fixed;
    bottom: 50px;
    right: 50px;
}

.progress {
    /* background-color:white !important; */
    border-radius: 20px !important;
    width: 300px;
    height: 25px !important;

}
</style>